<!-- Mesma tabela da mutação patrimonial: anos em colunas alinhadas, unidade no subtítulo. -->
<section class="pit-card">
  <div class="pit-card__head">
    <div>
      <h3 class="pit-title">Dívidas e ônus reais</h3>
      <p class="pit-caption">R$ mil · conforme a ficha Dívidas e Ônus Reais</p>
    </div>
    @if (lastYear() && debts().length) {
      <span class="pit-strong">{{ money(total()) }} em 31/12/{{ lastYear() }}</span>
    }
  </div>
  @if (debts().length) {
    <div class="pit-table-wrap">
      <table class="pit-table">
        <thead>
          <tr>
            <th>Credor e finalidade</th>
            @for (year of years(); track year) {
              <th class="num">31/12/{{ year }}</th>
            }
            <th>Garantia vinculada</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.debt.id) {
            <tr>
              <td class="debts__name">
                <p class="pit-strong">{{ row.creditor }}</p>
                @if (row.purpose) {
                  <p class="pit-caption debts__note" [title]="row.purpose">
                    {{ row.purpose }}
                  </p>
                }
              </td>
              @for (value of row.values; track $index; let last = $last) {
                <td class="num" [class.is-current]="last">{{ value }}</td>
              }
              <td class="debts__secured">
                @if (row.secured) {
                  <span [title]="row.secured">{{ row.secured }}</span>
                } @else {
                  —
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <p class="pit-text">Nenhuma dívida ou ônus real declarado.</p>
  }
</section>
